'use client';

type ElseHavenLogoProps = {
  className?: string;
  alt?: string;
  variant?: 'light' | 'dark';
};

export default function ElseHavenLogo({
  className = '',
  alt = 'ElseHaven logo',
  variant = 'light',
}: ElseHavenLogoProps) {
  const circleClasses = 'bg-white';
  const borderClasses = 'border border-black/10';

  return (
    <span
      role="img"
      aria-label={alt}
      className={`inline-flex items-center justify-center rounded-full overflow-hidden ${circleClasses} ${borderClasses} ${className}`.trim()}
    >
      <img
        src="/brand-logo.svg"
        alt=""
        aria-hidden="true"
        className="h-full w-full object-contain p-2"
      />
    </span>
  );
}
